import { Block, Heading, Toolbar } from "./Code";
import { Area, VirtualizedArea } from "./Area";
export type * from "./Code.types";

// Create a namespace object for exports
export const Code = {
  Block,
  Area,
  VirtualizedArea,
  Heading,
  Toolbar
};
